import React from 'react';
import { Form, Card, Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModeComponent from '../../ModeComponent';
import FormInputListSearch from '../../../../form/control/FormInputListSearch';

export default class OffWork extends ModeComponent {
  static propTypes = {
    activeStory: PropTypes.bool.isRequired,
    hideOpComplete: PropTypes.bool,
    hideRemedyCode: PropTypes.bool,
    causeText: PropTypes.string,
    correctionText: PropTypes.string,
  };

  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'causeInput';
  mode = 'OW';

  schema = {
    causeInput: {
      label: 'Cause',
      multiline: true,
    },
    correctionInput: {
      label: 'Correction',
      multiline: true,
    },
    opCompleteCheck: {
      label: 'Operation Complete',
      required: false,
    },
  };

  state = {
    causeInput: {
      value: '',
      validationState: null,
    },
    correctionInput: {
      value: '',
      validationState: null,
    },
    opCompleteCheck: {
      value: false,
      validationState: null,
    },
  };
  // end properties reset on each mount

  constructor(props) {
    super(props);

    // patch schema to remove required fields if story not active
    if (!props.activeStory) {
      this.schema.causeInput.required = false;
      this.schema.correctionInput.required = false;
      this.defaultFocus = 'opCompleteCheck';
    }

    this.handleCauseClick = this.handleCauseClick.bind(this);
    this.handleCorrectionClick = this.handleCorrectionClick.bind(this);
    this.handleRemedyCode = this.handleRemedyCode.bind(this);
  }

  handleCauseClick() {
    this.setState({ causeInput: { value: this.props.causeText } });
  }

  handleCorrectionClick() {
    this.setState({ correctionInput: { value: this.props.correctionText } });
  }

  handleRemedyCode(remedy = {}) {
    this.setState({
      correctionInput: { value: remedy.Correction || '' },
      causeInput: { value: remedy.Cause || '' },
    });
  }

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            <div className="section-header">Prior Job</div>
            {this.props.activeStory && (
              <>
                {this.props.hideRemedyCode !== true && (
                  <Row>
                    <Col sm={3} md={3} className="text-right">
                      <label>Remedy Code</label>
                    </Col>
                    <Col sm={9} md={9}>
                      <div className="form-edit-container">
                        <div className="control-wrapper">
                          <FormInputListSearch
                            search={{
                              page: 'SMF3',
                              filter: {
                                showInTimeClock: ['Y'],
                              },
                            }}
                            onFullSuggestionSelected={this.handleRemedyCode}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                {this.props.causeText !== '' && this.state.causeInput.value === '' && (
                  <div className="float-right">
                    <Button size="sm" onClick={this.handleCauseClick}>
                      Populate
                    </Button>
                  </div>
                )}

                {this.validatedTextInput('causeInput')}
                {this.props.correctionText !== '' && this.state.correctionInput.value === '' && (
                  <div className="float-right">
                    <Button size="sm" onClick={this.handleCorrectionClick}>
                      Populate
                    </Button>
                  </div>
                )}
                {this.validatedTextInput('correctionInput')}
              </>
            )}
            {this.props.hideOpComplete !== true && this.checkbox('opCompleteCheck')}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
